interface AnalyticsExportThemeTokens {
  page: string;
  title: string;
  subtitle: string;
  tile: string;
  chartSurface: string;
  tileLabel: string;
  tileValue: string;
  accent: string;
  footer: string;
  neutralBadge: string;
  mediaPlaceholder: string;
}

/**
 * The sheet is white so the margins the screenshot service adds stay
 * invisible, and the presentation shows the same sheets.
 */
export const analyticsExportTheme: AnalyticsExportThemeTokens = {
  page: 'tw-bg-white',
  title: 'tw-text-grayscale-190',
  subtitle: 'tw-text-grayscale-120',
  tile: 'tw-bg-[#F3EEFE]',
  chartSurface: 'tw-bg-[#F3EEFE]',
  tileLabel: 'tw-text-grayscale-180',
  tileValue: 'tw-text-grayscale-190',
  accent: 'tw-text-[#6D4AE0]',
  footer: 'tw-text-grayscale-100',
  neutralBadge: 'tw-bg-grayscale-20 tw-text-grayscale-190',
  mediaPlaceholder: 'tw-bg-grayscale-10',
};
